module.exports = __webpack_public_path__ + "img/photo-0073.321d3561.jpg";